(() => {
  'use strict';
  if (window.biopaEmailInitialized) return;
  window.biopaEmailInitialized = true;
  const editor = Boolean(window.Shopify?.designMode);
  const pageStarted = performance.now();
  const subscribedKey = 'biopaWelcomeConfirmedV2';
  const snoozeKey = 'biopaWelcomeHideUntilV2';
  const read = key => { try { return localStorage.getItem(key); } catch { return null; } };
  const write = (key, value) => { if (!editor) { try { localStorage.setItem(key, value); } catch {} } };
  function confirm(form) {
    form.querySelectorAll('.bp-signup-fields').forEach(el => { el.hidden = true; });
    const message = form.querySelector('[data-signup-success]');
    message.hidden = false;
    message.dataset.confirmed = 'true';
    form.querySelector('[data-signup-error]').hidden = true;
    write(subscribedKey, '1');
    document.dispatchEvent(new Event('biopa:subscribed'));
    message.focus();
  }
  function bindForms(scope = document) {
    scope.querySelectorAll('.bp-welcome-form').forEach(form => {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      if (form.querySelector('[data-confirmed="true"]')) write(subscribedKey, '1');
      let nativeNext = false;
      let busy = false;
      form.addEventListener('submit', async event => {
        if (editor) { event.preventDefault(); return; }
        if (nativeNext) return;
        event.preventDefault();
        if (busy || !form.reportValidity()) return;
        busy = true;
        const button = form.querySelector('[type="submit"]');
        const error = form.querySelector('[data-signup-error]');
        error.hidden = true;
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        let accepted = false;
        try {
          const response = await fetch(form.action, {method:'POST', body:new FormData(form), credentials:'same-origin', signal:controller.signal, headers:{Accept:'text/html'}});
          const destination = new URL(response.url, location.href);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const returnedForm = doc.getElementById(form.id);
          const blocked = /\/(challenge|checkpoint)(\/|$)/i.test(destination.pathname) || /captcha|challenge/i.test(doc.title) || Boolean(doc.querySelector('#shopify-challenge__container,.shopify-challenge__container'));
          accepted = response.ok && destination.origin === location.origin && !blocked && Boolean(returnedForm?.querySelector('[data-signup-success][data-confirmed="true"]')) && !returnedForm?.querySelector('[data-signup-error]:not([hidden])');
        } catch {} finally {
          clearTimeout(timeout);
          button.disabled = false;
          form.removeAttribute('aria-busy');
          busy = false;
        }
        if (accepted) confirm(form);
        else {
          nativeNext = true;
          form.requestSubmit(button);
        }
      });
    });
  }
  function bindPopup(scope = document) {
    const wrapper = scope.querySelector('[data-biopa-popup]');
    if (!wrapper || wrapper.dataset.bound) return;
    wrapper.dataset.bound = 'true';
    const modal = wrapper.querySelector('[data-ep-modal]');
    const overlay = wrapper.querySelector('[data-ep-overlay]');
    const form = wrapper.querySelector('form');
    let lastFocus;
    let priorOverflow = '';
    let timer;
    let scheduled = false;
    let open = false;
    const suppressed = () => read(subscribedKey) === '1' || Date.now() < Number(read(snoozeKey) || 0);
    function show(force = false) {
      if (!wrapper.isConnected || (!force && suppressed())) return;
      lastFocus = document.activeElement;
      priorOverflow = document.body.style.overflow;
      modal.hidden = overlay.hidden = false;
      modal.inert = false;
      modal.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      open = true;
      (form.querySelector('[data-confirmed="true"]') || form.querySelector('input[type="email"]')).focus();
    }
    function close(remember = true) {
      if (!open) return;
      modal.classList.remove('is-open'); overlay.classList.remove('is-open');
      modal.hidden = overlay.hidden = true; modal.inert = true;
      document.body.style.overflow = priorOverflow;
      open = false;
      if (remember) write(snoozeKey, String(Date.now() + Number(wrapper.dataset.hideDays || 7) * 86400000));
      lastFocus?.focus();
    }
    wrapper.querySelectorAll('[data-ep-close]').forEach(button => button.addEventListener('click', () => close()));
    overlay.addEventListener('click', () => close());
    modal.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const controls = [...modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex="0"]')].filter(el => !el.closest('[hidden]'));
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    function schedule() {
      if (scheduled || suppressed() || wrapper.dataset.enabled !== 'true') return;
      scheduled = true;
      const delay = Number(wrapper.dataset.delay || 20) * 1000;
      timer = setTimeout(() => show(), Math.max(0, delay - (performance.now() - pageStarted)));
    }
    if (editor) {
      document.addEventListener('shopify:section:select', event => { if (event.detail.sectionId === wrapper.dataset.section) show(true); });
      document.addEventListener('shopify:section:deselect', event => { if (event.detail.sectionId === wrapper.dataset.section) close(false); });
    } else if (!/\/(cart|checkouts?)(\/|$)/.test(location.pathname)) {
      if (form.querySelector('[data-confirmed="true"]') || form.querySelector('[data-signup-error]:not([hidden])')) show(true);
      else if (document.documentElement.classList.contains('biopa-loading')) document.addEventListener('biopa:loader-finished', schedule, {once:true});
      else schedule();
    }
    document.addEventListener('biopa:subscribed', () => clearTimeout(timer));
    document.addEventListener('shopify:section:unload', event => { if (event.detail.sectionId === wrapper.dataset.section) { clearTimeout(timer); close(false); } });
  }
  bindForms(); bindPopup();
  document.addEventListener('shopify:section:load', event => { bindForms(event.target); bindPopup(event.target); });
})();
